import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LogoutDialog',
  props: {
  // Hay que responder: tocar fuera no lo cierra
  persistent: {
    type: Boolean,
    default: false,
  },
  isVisible: {
    type: Boolean,
    required: true,
  },
  titulo: {
    type: String,
    default: "Confirmar",
  },
  mensaje: {
    type: String,
    default: "¿Estás seguro de que quieres proceder?",
  },
  textoConfirmar: {
    type: String,
    default: "Sí",
  },
  textoCancelar: {
    type: String,
    default: "No",
  },
},
  emits: ["update:isVisible", "confirmar", "cancelar"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emits = __emit;

const internalVisible = ref(props.isVisible);

watch(
  () => props.isVisible,
  (newVal) => {
    internalVisible.value = newVal;
  }
);

const confirmar = () => {
  emits("confirmar");
  internalVisible.value = false;
  emits("update:isVisible", false);
};

const cancelar = () => {
  emits("cancelar");
  internalVisible.value = false;
  emits("update:isVisible", false);
};

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: internalVisible.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalVisible).value = $event)),
    "max-width": "400",
    persistent: __props.persistent
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "headline text-wrap" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.titulo), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.mensaje), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                color: "blue darken-1",
                onClick: cancelar
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.textoCancelar), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                color: "blue darken-1",
                onClick: confirmar
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.textoConfirmar), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "persistent"]))
}
}

})